import { miscUiState } from '../globalState'
import { progressNotificationsProxy, setNotificationProgress } from '../react/NotificationProvider'

// Chunk loading progress is shown by ChunksLoadingCard, not as a notification.
const inventoryTexturesProgress = () => {
  if (!appViewer) return

  const startInventoryTexturesProgress = () => {
    if (!miscUiState.gameLoaded) return
    setNotificationProgress('inventoryTextures', {
      message: 'Processing GUI textures',
    })
  }

  customEvents.on('gameLoaded', () => {
    if (!appViewer.resourcesManager.currentResources?.guiAtlas) {
      startInventoryTexturesProgress()
    }

    bot.on('end', () => {
      // remove all progress notifications
      progressNotificationsProxy.loaders = []
    })
  })

  appViewer.resourcesManager.on('assetsInventoryStarted', () => {
    startInventoryTexturesProgress()
  })
  appViewer.resourcesManager.on('assetsInventoryReady', () => {
    setNotificationProgress('inventoryTextures', {
      delete: true,
    })
  })
}

setTimeout(() => {
  inventoryTexturesProgress()
})
